export default __webpack_public_path__ + "static/media/hot-qr-code-app-store.597fe94c.svg";